import settings from './settings';
import envConfig from '../../db-env-build';
const webfolder =  __PROD__ ? `${envConfig.envConfig}` : '';

const config = {
  ...settings,
  webfolder,
}

export default config;
